import { defineStore } from "pinia";

export const useLoaderStore = defineStore('loader', {
    state: () => ({
        show_full_screen_loader: true,
        show_small_loader: false,
        loading_msg: "Démarrage de l'application<span class='fas fa-spin fa-spinner'></span>",
    }),
    actions: {
        showFullScreenLoader(msg) {
            this.show_full_screen_loader = true
            this.show_small_loader = false
            this.loading_msg = msg
        },
        showSmallLoader(msg) {
            this.show_small_loader = true
            this.show_full_screen_loader = false
            this.loading_msg = msg
        },
        hideFullScreenLoader() {
            this.show_full_screen_loader = false
        },
        hideSmallLoader() {
            this.show_small_loader = false
        },
    },
})
